import { useEffect } from "react";

export const VoiceGreeting = () => {
  useEffect(() => {
    if (sessionStorage.getItem("nagel-welcomed")) return undefined;
    let audio = null;
    let fadeTimer = null;
    let cleanupFns = [];

    const fadeTo = (target, ms) => {
      if (!audio) return;
      clearInterval(fadeTimer);
      const steps = Math.max(1, Math.floor(ms / 50));
      const delta = (target - audio.volume) / steps;
      fadeTimer = setInterval(() => {
        if (!audio) return clearInterval(fadeTimer);
        audio.volume = Math.max(0, Math.min(1, audio.volume + delta));
        if ((delta > 0 && audio.volume >= target) || (delta < 0 && audio.volume <= target)) {
          clearInterval(fadeTimer);
        }
      }, 50);
    };

    const play = () => {
      audio = new Audio(`${process.env.REACT_APP_BACKEND_URL}/api/welcome-audio`);
      audio.volume = 0;
      audio
        .play()
        .then(() => {
          sessionStorage.setItem("nagel-welcomed", "1");
          fadeTo(1, 900);
          audio.addEventListener("timeupdate", () => {
            if (audio && audio.duration && audio.duration - audio.currentTime < 0.7) fadeTo(0, 600);
          });
        })
        .catch(() => {
          const onFirst = () => {
            window.removeEventListener("pointerdown", onFirst);
            if (!sessionStorage.getItem("nagel-welcomed")) play();
          };
          window.addEventListener("pointerdown", onFirst);
          cleanupFns.push(() => window.removeEventListener("pointerdown", onFirst));
        });
    };

    const t = setTimeout(play, 5000);
    return () => {
      clearTimeout(t);
      clearInterval(fadeTimer);
      cleanupFns.forEach((fn) => fn());
      if (audio) {
        audio.pause();
        audio = null;
      }
    };
  }, []);

  return null;
};
